'use strict';

var $ = require('jquery');
var scroll = require('../ui/scroll.js');
var layout = require('../ui/layout.js');

var visibility = 'visibility';
var hidden = 'hidden';
var visible = 'visible';

var classNames = {
	reviewDetailsPage: 'review-details-page',
	scrollableTabs: 'scrollable-tabs',
	scrollableTabsContainer: 'scrollable-tabs__container',
	tabs: 'tabs',
	tabsLink: 'tabs__link',
	active: 'active',
	indicator: 'indicator'
};

var modifier = {
	active: 'active'
};

function getScrollableTabsContainer() {
	return $.findByBem(classNames.scrollableTabsContainer);
}

function onClickIndicator() {
	var $indicator = $.findByBem(classNames.scrollableTabs, classNames.indicator);
	var $scrollableElement = getScrollableTabsContainer();
	var scrollValue = 10;

	$indicator.on('click', function () {
		var scrollRight = $scrollableElement.scrollLeft() + scrollValue;
		$scrollableElement.scrollLeft(scrollRight);
	});
}

function toggleIndicatorViewability() {
	var $container = getScrollableTabsContainer();

	if ($container === undefined || $container.length === 0) {
		return;
	}

	var scrolled = $container.scrollLeft();
	var maxWidth = $container[0].scrollWidth;

	// 5% of the total scroll width
	var minScrollThreshold = maxWidth * 0.05;
	var clientWidth = $container[0].clientWidth;

	var $indicator = $.findByBem(classNames.scrollableTabs, classNames.indicator);

	if (scrolled + clientWidth > maxWidth - minScrollThreshold) {
		$indicator.css(visibility, hidden);
	} else {
		$indicator.css(visibility, visible);
	}
}

function toggleIndicatorViewabilityOnScroll($scrollableTabsContainer) {
	$scrollableTabsContainer.on('scroll', function() {
		toggleIndicatorViewability();
	});
}

module.exports = {
	init: function() {
		if (layout.isMobile()) {

			// Scroll to active scrollable-tab tab in order to keep it in in view.
			var $scrollableTabsContainer = getScrollableTabsContainer();
			var $scrollableActiveTab = $.findByBem(classNames.active);
			scroll.scrollToHorizontal($scrollableTabsContainer, $scrollableActiveTab);
			
			toggleIndicatorViewability();

			toggleIndicatorViewabilityOnScroll($scrollableTabsContainer);

			onClickIndicator();

			// Scroll to active review-details-page tab in order to keep it in view.
			var $tabs = $.findByBem(classNames.reviewDetailsPage, classNames.tabs);
			var $activeTab = $.findByBem(classNames.reviewDetailsPage, classNames.tabsLink, modifier.active);
			scroll.scrollToHorizontal($tabs, $activeTab);
		}
	}
};